import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(['control', 'label', 'container']);

const variantCell = definePartsStyle((props) => ({
  container: {
    padding: 4,
    border: 'solid 1px transparent',
    borderColor: 'gray.200',
    borderRadius: '2xl',
    _checked: {
      borderColor: `${props.colorScheme}.400`,
      shadow: 'soft',
    },
  },
  label: {
    fontWeight: 'bold',
  },
  _checked: {
    container: {
      borderColor: `${props.colorScheme}.400`,
    },
  },
}));

export default defineMultiStyleConfig({
  defaultProps: {
    colorScheme: 'green',
  },
  variants: {
    cell: variantCell,
  },
});
